import { TextBox, TextBoxOptions } from "../../../framework/components/components/textBox";

export type MultiSelectOptions = TextBoxOptions;

export class MultiSelect extends TextBox {

    options: MultiSelectOptions;

    constructor(options: MultiSelectOptions) {
        super(options);
    }

}
